export {};
//# sourceMappingURL=NVMParser.js.map